export default __webpack_public_path__ + "static/media/slide-Agromart.0438a906.png";